import createIcon from '../../createIcon';

/**
 * @component @name WaterDrop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjY3IDYuNTUgNCAxMC40OCA0IDEzLjhDNCAxOC43OCA3LjggMjIgMTIgMjJDMTYuMiAyMiAyMCAxOC43OCAyMCAxMy44QzIwIDEwLjQ4IDE3LjMzIDYuNTUgMTIgMlpNNy44MyAxNEM4LjIgMTQgOC41IDE0LjI2IDguNTcgMTQuNjJDOC45OCAxNi44NCAxMC44NSAxNy42IDEyLjIxIDE3LjQ5QzEyLjY0IDE3LjQ3IDEzIDE3LjgxIDEzIDE4LjI0QzEzIDE4LjY0IDEyLjY4IDE4Ljk3IDEyLjI4IDE4Ljk5QzEwLjE1IDE5LjEyIDcuNjYgMTcuOSA3LjA5IDE0Ljg3QzcuMDEgMTQuNDIgNy4zNyAxNCA3LjgzIDE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const WaterDrop = createIcon('WaterDrop', [
  [
    'path',
    {
      d: 'M12 2C6.67 6.55 4 10.48 4 13.8C4 18.78 7.8 22 12 22C16.2 22 20 18.78 20 13.8C20 10.48 17.33 6.55 12 2ZM7.83 14C8.2 14 8.5 14.26 8.57 14.62C8.98 16.84 10.85 17.6 12.21 17.49C12.64 17.47 13 17.81 13 18.24C13 18.64 12.68 18.97 12.28 18.99C10.15 19.12 7.66 17.9 7.09 14.87C7.01 14.42 7.37 14 7.83 14Z',
      key: 'kuz2jj',
    },
  ],
]);

export default WaterDrop;
